import styled from '@emotion/styled';

const Container = styled.div`
  width: 100%;
  padding-right: 15px;
  padding-left: 15px;
  margin-right: auto;
  margin-left: auto;

  ${(props) =>
    props.normal &&
    `@media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 910px) {
        max-width: 720px;
    }

    @media (min-width: 1140px) {
        max-width: 960px;
    }

    @media (min-width: 1320px) {
        max-width: 1140px;
    }`}

  ${(props) =>
    props.small &&
    `@media (min-width: 576px) {
        max-width: 540px;
    }

    @media (min-width: 910px) {
        max-width: 720px;
    }

    @media (min-width: 1136px) {
        max-width: 1000px;
    }

    @media (min-width: 1275px) {
        max-width: 1120px;
    }

    @media (min-width: 1440px) {
        max-width: 1260px;
    }
    
    @media (min-width: 1620px) {
        max-width: 1440px;
    }`}
`;

export { Container };
